(function(){
  try{if(location.pathname.replace(/\/$/,'')==='/pages/suivi-de-commande'){location.replace('/search?view=suivi');return;}}catch(_e){}
  if(window.__niloV51313)return;window.__niloV51313=true;
  function initMenuLayer(){
    var toggle=document.getElementById('megamenu_mobile_toggle');
    var menu=document.querySelector('.header-mobile .menu-content');
    if(!toggle||!menu)return;
    function sync(){var open=toggle.classList.contains('on')||menu.classList.contains('on')||menu.getAttribute('aria-hidden')==='false';document.body.classList.toggle('nilo-menu-open',open);}
    var obs=new MutationObserver(sync);obs.observe(toggle,{attributes:true,attributeFilter:['class','aria-expanded']});obs.observe(menu,{attributes:true,attributeFilter:['class','aria-hidden','style']});
    document.addEventListener('click',function(e){
      if(e.target.closest('#megamenu_mobile_toggle'))setTimeout(sync,0);
      if(e.target.closest('.megamenu_mobile_close')||e.target.closest('.header-mobile .menu-content a'))setTimeout(function(){document.body.classList.remove('nilo-menu-open');},30);
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')document.body.classList.remove('nilo-menu-open');});
    sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initMenuLayer);else initMenuLayer();
})();
